import { render, staticRenderFns } from "./DocumentCreditor.vue?vue&type=template&id=51d10107&scoped=true&"
import script from "./DocumentCreditor.vue?vue&type=script&lang=js&"
export * from "./DocumentCreditor.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCreditor.vue?vue&type=style&index=0&id=51d10107&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d10107",
  null
  
)

export default component.exports